module.exports = __webpack_public_path__ + "img/noDataPic.291c078e.png";